import { render } from "./member.vue?vue&type=template&id=24a650e3&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"

import "./member.vue?vue&type=style&index=0&id=24a650e3&lang=scss&scoped=true"
import "./member.vue?vue&type=style&index=1&id=24a650e3&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a650e3"]])

export default __exports__